(() => {
  if (typeof window.customElements.get('testimonials-section') !== 'undefined') {
    return;
  }

  window.customElements.define(
    'testimonials-section',
    class Testimonials extends HTMLElement {
      constructor() {
        super();

        this.carousel = this.querySelector('[data-testimonials-carousel]');

        this.initTestimonials();
      }

      initTestimonials() {
        try {
          this.setupSwiper();
        } catch (error) {
          console.error('There was a problem with the Testimonials component:', error);
        }
      }

      setupSwiper() {
        if (!this.carousel) {
          return;
        }

        const prevButton = this.carousel.querySelector('[data-testimonials-carousel-prev]');
        const nextButton = this.carousel.querySelector('[data-testimonials-carousel-next]');

        this.swiper = new Swiper(this.carousel, {
          slidesPerView: 'auto',
          spaceBetween: 10,
          centeredSlides: false,
          loop: false,
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
          navigation: {
            nextEl: nextButton,
            prevEl: prevButton,
          },
        });

        return this.swiper;
      }
    }
  );
})();
